import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import "./App.css"
import { Toaster } from './components/ui/sonner';

// Layout Components
import Header from './components/Header';
import Footer from './components/Footer';
import CookieConsent from './components/CookieConsent';

// Pages
import HomePage from './pages/HomePage';
import TechnologyPage from './pages/TechnologyPage';
import HowItWorksPage from './pages/HowItWorksPage';
import AnimationPage from './pages/AnimationPage';
import WhyNonLithiumPage from './pages/WhyNonLithiumPage';
import ComparisonPage from './pages/ComparisonPage';
import ProductsPage from './pages/ProductsPage';
import TractionBatteryPage from './pages/TractionBatteryPage';
import EnergyStoragePage from './pages/EnergyStoragePage';
import RailSystemsPage from './pages/RailSystemsPage';
import SafetyPage from './pages/SafetyPage';
import ValidationPage from './pages/ValidationPage';
import AboutPage from './pages/AboutPage';
import MediaPage from './pages/MediaPage';
import ContactPage from './pages/ContactPage';
import EMobilityPage from './pages/EMobilityPage';
import CareersPage from './pages/CareersPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import LegalNoticePage from './pages/LegalNoticePage';

function App() {
  return (
    <Router>
      <div className="App bg-gray-950 min-h-screen">
        <Toaster position="top-right" richColors />
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            {/* Technology Routes */}
            <Route path="/multi-ion-technology" element={<TechnologyPage />} />
            <Route path="/multi-ion-technology/how-it-works" element={<HowItWorksPage />} />
            <Route path="/multi-ion-technology/animation" element={<AnimationPage />} />
            <Route path="/multi-ion-technology/why-non-lithium" element={<WhyNonLithiumPage />} />
            <Route path="/multi-ion-technology/comparison" element={<ComparisonPage />} />
            {/* Products Routes */}
            <Route path="/products" element={<ProductsPage />} />
            <Route path="/products/traction-battery" element={<TractionBatteryPage />} />
            <Route path="/products/energy-storage" element={<EnergyStoragePage />} />
            <Route path="/products/rail-systems" element={<RailSystemsPage />} />
            {/* Other Routes */}
            <Route path="/safety" element={<SafetyPage />} />
            <Route path="/validation" element={<ValidationPage />} />
            <Route path="/validation/performance" element={<ValidationPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/media" element={<MediaPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/e-mobility" element={<EMobilityPage />} />
            <Route path="/careers" element={<CareersPage />} />
            <Route path="/privacy" element={<PrivacyPolicyPage />} />
            <Route path="/legal" element={<LegalNoticePage />} />
          </Routes>
        </main>
        <Footer />
        <CookieConsent />
      </div>
    </Router>
  );
}

export default App;
